import "./ProjectNeighboursSelect.css";

import { ListItemText, MenuItem, TextField } from "@mui/material";

export const ProjectNeighboursSelect = ({ options, value, setValue }) => {
	return (
		<div className="ProjectNeighboursSelect TextBoxModifyMui">
			<TextField
				select
				size="small"
				label="Проект для сравнения"
				value={value}
				onChange={(e) => setValue(e.target.value)}
				sx={{
					"& legend": {
						fontSize: "9px",
					},
					"& .MuiListItemText-root span": {
						fontSize: "12px",
					},
				}}
			>
				{options.map((option) => (
					<MenuItem key={option.id} title={option.name} value={option} sx={{ maxWidth: "100%!important" }}>
						<ListItemText primary={option.name} />
					</MenuItem>
				))}
			</TextField>
		</div>
	);
};
